// Vendors
import React from 'react';
import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';

// Components
import Header from '@/components/molecules/Header/Header';

const MainLayout: React.FC = () => {
  return (
    <Box className="main_wrapper">
      <Header />
      <Container component="main" className="main_container">
        <Outlet />
      </Container>
    </Box>
  );
};

export default MainLayout;
